import { doc, onSnapshot, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const DEFAULT_DEPARTMENT_NAMES = [
  'Website',
  'Management',
  'DTP',
  'Social Media',
  'Faculty',
  'Sales',
  'Marketing',
];

/** Legacy label from older data / settings — treat as Social Media everywhere in UI. */
export function canonicalDepartmentLabel(name) {
  const s = String(name || '').trim();
  if (!s) return 'N/A';
  if (/^youtube$/i.test(s)) return 'Social Media';
  return s;
}

const SETTINGS_REF = () => doc(db, 'settings', 'app');

function normalizeList(names) {
  const seen = new Set();
  const out = [];
  for (const n of names || []) {
    let t = String(n || '').trim();
    if (/^youtube$/i.test(t)) t = 'Social Media';
    if (!t || t.length > 80) continue;
    const k = t.toLowerCase();
    if (seen.has(k)) continue;
    seen.add(k);
    out.push(t);
  }
  return out;
}

/**
 * Real-time list for dropdowns. Falls back to defaults if doc missing or empty.
 */
export function subscribeDepartments(callback) {
  if (!db) {
    callback(DEFAULT_DEPARTMENT_NAMES);
    return () => {};
  }
  return onSnapshot(
    SETTINGS_REF(),
    (snap) => {
      let raw = [];
      if (snap.exists()) {
        const v = snap.data().departmentNames;
        raw = Array.isArray(v) ? v : [];
      }
      const names = normalizeList(raw);
      callback(names.length ? names : DEFAULT_DEPARTMENT_NAMES);
    },
    () => callback(DEFAULT_DEPARTMENT_NAMES)
  );
}

/** HR-only: replace full list */
export async function saveDepartmentNames(names) {
  if (!db) throw new Error('Firestore not available');
  const list = normalizeList(names);
  if (list.length === 0) throw new Error('At least one department is required');
  await setDoc(
    SETTINGS_REF(),
    { departmentNames: list, updatedAt: new Date().toISOString() },
    { merge: true }
  );
}
